export const CancelToken = Symbol.for('Upload cancel token')
